import { render, staticRenderFns } from "./curve.vue?vue&type=template&id=4adf5f5f&scoped=true&"
import script from "./curve.vue?vue&type=script&lang=js&"
export * from "./curve.vue?vue&type=script&lang=js&"
import style0 from "./curve.vue?vue&type=style&index=0&id=4adf5f5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf5f5f",
  null
  
)

export default component.exports